import { WIZARD_STATUSES } from '../constants';
import { haptic } from '../../../utils/haptic';

const MAX_SELECT = 2;

const GRID_STYLE: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 8,
};

const CARD_STYLE = (color: string, active: boolean): React.CSSProperties => ({
  padding: '10px 12px',
  borderRadius: 8,
  border: `1px solid ${active ? color : 'rgba(255,255,255,0.07)'}`,
  background: active ? `rgba(${hexToRgb(color)}, 0.08)` : 'rgba(255,255,255,0.04)',
  color: '#f4f0ff',
  fontSize: '0.8125rem',
  fontWeight: 500,
  cursor: 'pointer',
  textAlign: 'left' as const,
  transition: 'border-color 0.2s, background 0.2s',
});

function hexToRgb(hex: string): string {
  if (hex.startsWith('var(')) return '120, 80, 255'; // fallback for var(--border)
  const m = hex.match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i);
  if (!m) return '120, 80, 255';
  return `${parseInt(m[1], 16)}, ${parseInt(m[2], 16)}, ${parseInt(m[3], 16)}`;
}

export function StatusSelector({
  selected,
  onChange,
}: {
  selected: string[];
  onChange: (statuses: string[]) => void;
}) {
  const atMax = selected.length >= MAX_SELECT;

  const toggle = (value: string) => {
    haptic.select();
    if (selected.includes(value)) {
      onChange(selected.filter((s) => s !== value));
    } else if (!atMax) {
      onChange([...selected, value]);
    }
  };

  return (
    <div>
      <div style={GRID_STYLE}>
        {WIZARD_STATUSES.map((s) => {
          const active = selected.includes(s.value);
          const disabled = !active && atMax;
          return (
            <button
              key={s.value}
              type="button"
              style={{
                ...CARD_STYLE(s.color, active),
                opacity: disabled ? 0.5 : 1,
                cursor: disabled ? 'not-allowed' : 'pointer',
              }}
              onClick={() => !disabled && toggle(s.value)}
              aria-pressed={active}
            >
              {s.label}
            </button>
          );
        })}
      </div>
      {selected.length > 0 && (
        <div style={{ marginTop: 12 }}>
          <div style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', marginBottom: 6 }}>
            Выбрано
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {selected.map((v) => {
              const s = WIZARD_STATUSES.find((x) => x.value === v);
              return (
                <span
                  key={v}
                  style={{
                    padding: '6px 10px',
                    borderRadius: 8,
                    border: `1px solid ${s?.color ?? 'rgba(255,255,255,0.2)'}`,
                    background: s ? `rgba(${hexToRgb(s.color)}, 0.08)` : 'rgba(255,255,255,0.04)',
                    color: '#f4f0ff',
                    fontSize: '0.8125rem',
                  }}
                >
                  {s?.label ?? v}
                </span>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
